import { render } from "./pb-formexpedition.vue?vue&type=template&id=6c149ee6"
import script from "./pb-formexpedition.vue?vue&type=script&lang=js"
export * from "./pb-formexpedition.vue?vue&type=script&lang=js"

import "./pb-formexpedition.vue?vue&type=style&index=0&id=6c149ee6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__